import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GtmService } from '../../services/gtm/gtm.service';
import { RouteTrackingService } from '../../services/route-tracking.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-gtm-consolidated-diagnostic',
  templateUrl: './gtm-consolidated-diagnostic.component.html',
  styleUrls: ['./gtm-consolidated-diagnostic.component.scss'],
})
export class GtmConsolidatedDiagnosticComponent implements OnInit {
  diagnosticInfo: any = null;
  navigationStats: any = {};
  hasRouteActivity = false;
  isProductionMode = environment.production;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GtmConsolidatedDiagnosticComponent>,
    private gtmService: GtmService,
    private routeTrackingService: RouteTrackingService
  ) {}

  ngOnInit(): void {
    if (!this.isProductionMode) {
      this.loadDiagnosticInfo();
      this.loadRouteTrackingInfo();
    }
  }

  loadDiagnosticInfo(): void {
    this.diagnosticInfo = this.gtmService.getGTMDiagnosticInfo();
  }

  loadRouteTrackingInfo(): void {
    this.navigationStats = this.routeTrackingService.getNavigationStats();
    this.hasRouteActivity = this.navigationStats.total_navigations > 0;
  }

  // GTM Diagnostic Methods
  runGtmDiagnostics(): void {
    this.gtmService.runDiagnostics();
    this.loadDiagnosticInfo();
  }

  sendTestEvent(): void {
    this.gtmService.sendTestEvent();
  }

  copyGtmToClipboard(): void {
    const infoText = JSON.stringify(this.diagnosticInfo, null, 2);
    navigator.clipboard
      .writeText(infoText)
      .then(() => {
        console.log('📋 GTM info copied to clipboard');
      })
      .catch((err) => {
        console.error('❌ Error copying:', err);
      });
  }

  getStatusIcon(status: boolean): string {
    return status ? '✅' : '❌';
  }

  getStatusColor(status: boolean): string {
    return status ? '#4caf50' : '#f44336';
  }

  getChipClass(status: boolean): string {
    return status ? 'status-chip success' : 'status-chip error';
  }

  // Route Tracking Methods
  sendTestRouteEvent(): void {
    this.routeTrackingService.trackManualNavigation('/test-route', { test: true });
    this.loadRouteTrackingInfo();
  }

  exportRouteData(): void {
    const data = {
      navigationStats: this.navigationStats,
    };
    const dataStr = JSON.stringify(data, null, 2);
    navigator.clipboard
      .writeText(dataStr)
      .then(() => {
        console.log('📋 Route data copied to clipboard');
      })
      .catch((err) => {
        console.error('❌ Error copying route data:', err);
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  refreshAll(): void {
    this.loadDiagnosticInfo();
    this.loadRouteTrackingInfo();
  }
}
